import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingHistoryService } from '../services/routingHistory.service';
import { TenantService } from '../services/tenant.service';
import { filter, first, takeUntil } from 'rxjs/operators';
import { UserService } from '../services/user.service';
import { ItemService, PermissionService } from '../services';
import { Subject } from 'rxjs';
import { ItemEditContextModel } from '../services/item.service';

@Component({
    selector: 'admin',
    styles: [`
        .active-link {
            background: #D7D7D7;
        }

        mat-sidenav-container.mat-drawer-container.mat-sidenav-container {
            height: calc(100vh - 66px) !important;
            min-height: calc(100vh - 66px) !important;
        }
    `],
    template: `
        <mat-toolbar color="primary">
            <app-nav></app-nav>
            <span fxFlex></span>
            <logo></logo>
            <span fxFlex></span>
            <create-topic-link></create-topic-link>
            <app-right-nav></app-right-nav>
        </mat-toolbar>
        <mat-sidenav-container fxFill [autosize]="true">
            <mat-sidenav opened="true" mode="side">
                <mat-nav-list>
                    <h4 matHeader style="padding-left: 5px;">{{user?.firstName}} {{user?.lastName}}</h4>
                    <a mat-list-item 
                       [routerLink]="['/', 'settings', 'profile']"
                       routerLinkActive="active-link">Profile</a>
                    <a mat-list-item
                       *ngIf="!userIsCatalogManager"
                       [routerLink]="['/', 'settings', 'schedule']"
                       routerLinkActive="active-link">My Briefing</a>
                    <a mat-list-item
                       *ngIf="userSubscriptionsEnabled" 
                       [routerLink]="['/', 'settings', 'subscription']"
                       routerLinkActive="active-link">Subscription</a>
                    <a mat-list-item 
                       *ngIf="userIsAdmin"
                       [routerLink]="['/', 'settings', 'invite']"
                       routerLinkActive="active-link">Invite to Team</a>
                    <a mat-list-item (click)="logOut()">Log Out</a>
                    <mat-divider *ngIf="userIsAdmin"></mat-divider>
                    <h4 matHeader *ngIf="userIsAdmin" style="padding-left: 5px;">{{tenant?.name}} admin</h4>
                    <a mat-list-item
                       *ngIf="userIsAdmin && !userIsCatalogManager"
                       [routerLink]="['/', 'settings', 'account']"
                       routerLinkActive="active-link">Account Settings</a>
                    <a mat-list-item
                       *ngIf="userIsAdmin && categorizationEnabled && !userIsCatalogManager"
                       [routerLink]="['/', 'settings', 'categories']"
                       routerLinkActive="active-link">Categories</a>
                    <a mat-list-item
                       *ngIf="userIsAdmin && !userIsCatalogManager"
                       [routerLink]="['/', 'settings', 'groups']"
                       routerLinkActive="active-link">Groups</a>
                    <a mat-list-item
                       *ngIf="userIsAdmin" 
                       [routerLink]="['/', 'settings', 'members']"
                       routerLinkActive="active-link">Members</a>
                    <a mat-list-item
                       *ngIf="userIsAdmin && manageBriefingsAllowed" 
                       [routerLink]="['/', 'settings', 'briefings']"
                       routerLinkActive="active-link">Briefings</a>
                    <a mat-list-item
                       *ngIf="userIsAdmin" 
                       [routerLink]="['/', 'settings', 'personalBriefings']"
                       routerLinkActive="active-link">Personal Briefings</a>
                    <a mat-list-item 
                       *ngIf="userIsAdmin && isPartner"
                       [routerLink]="['/', 'settings', 'partner']"
                       routerLinkActive="active-link">Sites</a>
                    <a mat-list-item
                       *ngIf="userIsAdmin && !userIsCatalogManager"
                       [routerLink]="['/', 'settings', 'sources']"
                       routerLinkActive="active-link">Sources</a>
                    <a mat-list-item
                       *ngIf="userIsAdmin && (isStriped || isSubscriptionTenant)"
                       [routerLink]="['/', 'settings', 'subscriptionPlan']"
                       routerLinkActive="active-link">Subscription Plan</a>
                    <a mat-list-item
                       *ngIf="userIsAdmin && !userIsCatalogManager"
                       [routerLink]="['/', 'settings', 'tags']"
                       routerLinkActive="active-link">Tags</a>
                    <a mat-list-item
                       *ngIf="userIsAdmin && !userIsCatalogManager"
                       [routerLink]="['/', 'settings', 'topics']"
                       routerLinkActive="active-link">Topics</a>
                    <a mat-list-item
                       *ngIf="userIsCatalogManager"
                       [routerLink]="['/', 'settings', 'shared', 'catalogs']"
                       routerLinkActive="active-link">Shared Catalogs</a>
                    <a mat-list-item
                       *ngIf="userIsCatalogManager"
                       [routerLink]="['/', 'settings', 'shared', 'sources']"
                       routerLinkActive="active-link">Shared Sources</a>
                    <a mat-list-item
                       *ngIf="userIsCatalogManager"
                       [routerLink]="['/', 'settings', 'shared', 'topics']"
                       routerLinkActive="active-link">Shared Topics</a>
                       <a mat-list-item
                       *ngIf="userIsCatalogManager"
                       [routerLink]="['/', 'settings', 'shared', 'tags']"
                       routerLinkActive="active-link">Shared Tags</a>
                    <a mat-list-item
                       *ngIf="userIsAdmin && showOtherAdministration" 
                       [href]="adminLink()">Other Administrative</a>
                </mat-nav-list>
            </mat-sidenav>
            <mat-sidenav-content>
                <router-outlet></router-outlet>
            </mat-sidenav-content>
            <mat-sidenav [autoFocus]="false" mode="over" position="end" #rightSideNav (closedStart)="closingTime()">
                <item-viewer *ngIf="focusedItemContext" 
                             [itemContext]="focusedItemContext"
                             [isSource]="focusedItemContext?.isSource"
                             [curating]="focusedItemContext?.isCuration"
                             (close)="close()"></item-viewer>
                <div *ngIf="focusedItemEditContext">
                    <item-post [itemEditContextModel]="focusedItemEditContext"
                               (done)="close(100)"></item-post>
                </div>
            </mat-sidenav>
        </mat-sidenav-container>
    `
})
export class AdminComponent implements OnInit, OnDestroy {
    @ViewChild('rightSideNav', { static: true }) rightSideNav;
    private cleanupTime = new Subject<void>();
    focusedItemContext: any;
    focusedItemEditContext: ItemEditContextModel;
    returnTo: string;
    isStriped: boolean;
    isSubscriptionTenant: boolean;
    userSubscriptionsEnabled: boolean;
    userIsAdmin: boolean;
    isPartner: boolean;
    manageBriefingsAllowed: boolean;
    tenant: any;
    user: any;
    showOtherAdministration: any;
    categorizationEnabled: boolean;
    userIsCatalogManager: boolean;
    
    constructor(private router: Router,
                private itemService: ItemService, 
                private routingHistoryService: RoutingHistoryService,
                private permissionService: PermissionService,
                private tenantService: TenantService,
                private userService: UserService) {}

    ngOnInit(): void {
        this.itemService.focusedItemEdit.pipe(takeUntil(this.cleanupTime))
        .subscribe(context => {
            this.focusedItemEditContext = context;
            if (context) {
                this.rightSideNav?.open();
            } else {
                this.rightSideNav?.close();
            }
        });
        this.itemService.focusedItem.pipe(takeUntil(this.cleanupTime))
        .subscribe(item => {
            this.focusedItemContext = item;
            if (item) {
                this.rightSideNav.open();
            } else {
                this.rightSideNav.close();
            }
        });
        this.tenantService.getCurrentTenant().pipe(first())
        .subscribe(tenant => {
            this.tenant = tenant;
            this.showOtherAdministration = this.tenant.settings.showOtherAdministration; 
            this.isStriped = tenant.stripeCustomerId;
            this.isSubscriptionTenant = tenant.settings.paymentType === 'STRIPE';
            const allowedBriefingTypes = this.tenant.settings.allowedBriefingTypes;
            this.manageBriefingsAllowed = (allowedBriefingTypes && (allowedBriefingTypes.includes('SLACK') || allowedBriefingTypes.includes('SENDGRID')));
            this.userSubscriptionsEnabled = tenant.settings.paymentType === 'INDIVIDUAL' && !this.userService.isCurrentUserAdmin() && !this.userService.getCurrentUser().emailAddress.endsWith(tenant.settings.excludeEmailFilter);
            this.categorizationEnabled = tenant.settings.hideCategories !== 'true';
        });
        this.user = this.userService.getCurrentUser();
        this.isPartner = this.permissionService.userHasPermission(this.user, {action: 'CREATE_TENANTS'});
        this.userIsAdmin = this.userService.isCurrentUserAdmin();
        this.userIsCatalogManager = this.userService.isCurrentUserCatalogManager();
        this.returnTo = this.routingHistoryService.getPreviousUrl();
    }
    
    goBack(): void {
        if (this.router.url === '/settings/sources/create') {
            this.router.navigate(['/settings', 'sources']);
        } else if (this.router.url.includes('/settings/sources/create/')) {
            this.router.navigate(['/settings', 'sources', 'create']);
        } else {
            this.router.navigateByUrl(this.returnTo.startsWith('/login') ? '/' : this.returnTo);
        }
    }

    logOut = () => {
        const isPublic = this.tenant.settings.publicTopics === 'true';
        this.userService.signOut(isPublic)
        .pipe(filter(() => isPublic))
        .subscribe(() => this.router.navigate(['/browse']));
    }

    adminLink(): string {
        return `${window.location.protocol}//${window.location.host}/streams`;
    }

    close(): void {
        this.rightSideNav.close();
    }

    closingTime(): void {
        this.itemService.itemClosing.next();
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
        this.cleanupTime.complete();
    }
}